/// <amd-module name="Feed/Connect/Redux/ConnectToFeed/ConnectToFeedActions" />
import { ActionsUnion, createAction, trackedAction } from "redux/Utils/ActionHelper";

import { ITool, ToolId } from "../../Tool";

export const enum ConnectToFeedActionTypes {
    ToolsInitialized = "ConnectToFeed/ToolsInitialized",
    ToolSelected = "ConnectToFeed/ToolSelected",
    GetTools = "ConnectToFeed/GetTools",
    DismissFirstTimeMessage = "ConnectToFeed/FirstTimeMessage/Dismiss",
    InitializeMessageDismissedTools = "ConnectToFeed/FirstTimeMessage/Initialized"
}

export const ConnectToFeedActions = {
    toolsInitialized: (tools: ITool[]) => createAction(ConnectToFeedActionTypes.ToolsInitialized, tools),
    toolSelected: (tool: ITool | undefined) => trackedAction(createAction(ConnectToFeedActionTypes.ToolSelected, tool)),
    getTools: (tool?: ITool) => createAction(ConnectToFeedActionTypes.GetTools, tool),
    dismissFirstTimeMessage: (toolId: ToolId) =>
        trackedAction(createAction(ConnectToFeedActionTypes.DismissFirstTimeMessage, toolId)),
    initializeMessageDismissedTools: (toolIds: ToolId[]) =>
        createAction(ConnectToFeedActionTypes.InitializeMessageDismissedTools, toolIds)
};

export type ConnectToFeedActions = ActionsUnion<typeof ConnectToFeedActions>;
